import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import EnquiryDetailsComp  from "./Component/EnquiryDetailsComp"

const EnquiryDetails =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EnquiryDetailsComp />
        </div>
        <Footer />
        </>
    )
}

export default EnquiryDetails